import {
  CustomGetJobCostingLapsedReportQuery,
  CustomGetJobCostingLapsedReportQueryVariables,
  useCustomGetJobCostingLapsedReportQuery,
} from "generated/graphql";
import { useCallback, useMemo } from "react";

const useGetJobCostingLapsedReport = ({
  variables,
}: {
  variables: CustomGetJobCostingLapsedReportQueryVariables;
}) => {
  const {
    data: graphqlData,
    error,
    loading,
  } = useCustomGetJobCostingLapsedReportQuery({
    variables,
    fetchPolicy: "network-only",
  });

  const getData = useCallback(({ data }: { data: CustomGetJobCostingLapsedReportQuery }) => {
    return data?.getJobCostingLapsedReport?.data || [];
  }, []);

  const getPaginatorInfo = useCallback(
    ({ data }: { data: CustomGetJobCostingLapsedReportQuery }) => {
      return data?.getJobCostingLapsedReport?.paginatorInfo || null;
    },
    []
  );

  const data = useMemo(() => getData({ data: graphqlData }), [getData, graphqlData]);
  const paginatorInfo = useMemo(
    () => getPaginatorInfo({ data: graphqlData }),
    [getPaginatorInfo, graphqlData]
  );

  return {
    loading,
    data,
    error,
    getData,
    getPaginatorInfo,
    paginatorInfo,
  } as const;
};

export default useGetJobCostingLapsedReport;
